// extracted by mini-css-extract-plugin
export default {"orb":"Orb_orb__lRlOi","pulse":"Orb_pulse__oSV7i"};